<div class="wrap">
  <div class="reset_password" [style.grid-template-rows]="isConfirm ? '1fr' : '50px 3fr'">
    <ng-container *ngIf="!isConfirm">
      <h2>Changer le mot de passe</h2>
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <a href="https://www.ramdamfestival.be/" target="_blank" class="ramdam" ><img  src="assets/img/TOURNAI RAMDAM FEST - logo BLC&RGE.png" alt="logo_ramdam"></a>
    
        <div class="powered_by_bizzdev">
          <span>Powered by</span>
          <div class="bizzdev">
            <img src="assets/icons/logo_bizzdev.jpg" alt=""> 
            <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
          </div>
        </div>
      
        <mat-form-field appearance="outline">
          <mat-label>Nouveau mot de passe</mat-label>
          <input matInput type="password" formControlName="newPassword" autocomplete="off">
        </mat-form-field>
    
        <mat-form-field appearance="outline">
          <mat-label>Confirmation du mot de passe</mat-label>
          <input matInput type="password" formControlName="confirmNewPassword" autocomplete="off">
        </mat-form-field>
        
        <button type="submit" [disabled]="changePasswordForm.invalid" [style.opacity]="changePasswordForm.valid ? 1 : .5">Changer mon mot de passe</button>
       
      </form>
    </ng-container>

    <app-validation-animation *ngIf="isConfirm" [text]="'Mot de passe modifié'"></app-validation-animation>
  </div>
</div >
